import React, { useState, useContext, useEffect } from "react";

import { fetchData, reportInvalidInfo } from "../../data/Contentapi";
import { MyContext } from "../../globalContext";
import ErrorFallBackComponent from "../../utils/ErrorFallBackComponent";
import {
  IconButton,
  Box,
  CircularProgress,
  Link,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getConfig } from "./../../loadconfig";
import { useTranslation } from "react-i18next";
import EmailIcon from "@mui/icons-material/Email";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ProviderDetailsDownload from "../downloads/ProviderDetailsPDF";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";

import ErrorAuthComponent from "../../utils/ErrorAuthComponent";
import { commonPublishEvent } from "../../utils/PublishEventMethod";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import EmailPopup from "../Common/EmailPopup";
import ViewProviderDetailsTable from "./ViewProviderDetailsTable";

const useStyles = makeStyles({
  topScrollPaper: {
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
});

const ViewProviderDetails = () => {
  const { t } = useTranslation();
  const [details, setDetails] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [metaData, setMetaData] = useState([]);
  const mycontext = useContext(MyContext);

  const {
    jwtToken,
    setJwtTokenData,
    setRecaptchaTokenData,
    setSessionIdData,
    selectedForDetails,
    setShowDetailResultData,
    languageData,
    setSearchPageNumberData,
    searchPageNumber,
    getSessionIdData,
    showDetailsResult
  } = useContext(MyContext);

  const [comments, setComments] = useState("");
  const [showPopupReport, setShowPopupReport] = useState(false);
  const [showPopupSuccessReport, setShowPopupSuccessReport] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [submitBtn, setSubmitBtn] = useState(true);
  const [charLength, setCharLength] = useState(250);
  const [checkboxState, setCheckboxState] = React.useState({
    address: false,
    phone: false,
    genderRepo: false,
    specialty: false,
    deceased: false,
    retired: false,
    noLongerAtThisPracticeAddress: false,
    notAcceptingNewPatients: false,
  });

  const classes = useStyles();
  let config = getConfig();

  //reportInvalidRInformation
  const handleCloseReportInvalidInfo = () => {
    setShowPopupReport(false);
    setCheckboxState({
      address: false,
      phone: false,
      genderRepo: false,
      specialty: false,
      deceased: false,
      retired: false,
      noLongerAtThisPracticeAddress: false,
      notAcceptingNewPatients: false,
    });
    setComments("");
    setSubmitBtn(true);
    setCharLength(250);
  };
  const handleCloseSuccessReportInvalidInfo = () => {
    setShowPopupSuccessReport(false);
  };

  const handleReportInvalidInformation = async () => {
    setShowPopupReport(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleSuccessReportInvalidInformation = async () => {
    setShowPopupSuccessReport(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCommentChange = (event) => {
    if (event.target.value.length > 250) {
      return;
    }
    let charlen = parseInt(250) - parseInt(event.target.value.length);
    setCharLength(charlen);
    setComments(event.target.value);

    validation();
  };

  const handleChange = (event) => {
    setCheckboxState({
      ...checkboxState,
      [event.target.name]: event.target.checked,
    });
    const { name, checked } = event.target;

    setSelectedCheckboxes((prevSelected) => {
      if (checked) {
        return [...prevSelected, name];
      }
    });

    setTimeout(() => {
      validation();
    }, 1000);
  };

  const validation = () => {
    if (selectedCheckboxes.length >= 1 && comments !== "") {
      setSubmitBtn(false);
    }
  };

  const {
    address,
    phone,
    gender,
    specialty,
    deceased,
    retired,
    noLongerAtThisPracticeAddress,
    notAcceptingNewPatients,
  } = checkboxState;

  const handleSubmitReport = async () => {
    let mp3Id = "";
    let credId = "";
    details?.alternateIDList?.alternateID?.map((mp) => {
      if (mp.alternateIDType == "MP3ID") {
        mp3Id = mp.alternateIDNumber;
      }
      if (mp.alternateIDType == "CREDID") {
        credId = mp.alternateIDNumber;
      }
    });
    // providerType: selectedForDetails?.alternateIDType,
    let invalidReportData = {
      providerId: mp3Id,
      providerName:
        details?.providerDetails?.practitioner?.personalDetails?.lastName +
        "," +
        details?.providerDetails?.practitioner?.personalDetails?.firstName +
        "," +
        details?.providerDetails?.practitioner?.personalDetails?.middleName +
        "," +
        details?.providerDetails?.practitioner?.educationList?.education[0]
          ?.degree?.degreeCode,
      providerType: details?.providerType,
      invalidInfoList: {
        invalidInfo: selectedCheckboxes,
      },
      comments: comments,
      credId: credId,
    };
    let searchCriteria = selectedForDetails;

    try {
      const data = await reportInvalidInfo(
        config.REPORT_INVALID_INFO_URL,
        invalidReportData,
        mycontext
      );

      setMetaData(data.meta);
      if (data.meta && data.meta.statusCode === "A") {
        setJwtTokenData("");
        setRecaptchaTokenData("");
        setSessionIdData(false);
        //return;
      }
      if (data.meta && data.meta.statusCode === "C") {
        handleCloseReportInvalidInfo();
        handleSuccessReportInvalidInformation();
      }

      setLoading(false);
    } catch (e) {
      console.error("Error fetching provider details:", e);
    }
    let eventData = {
      Locale: languageData,
      "Provider ID": searchCriteria.alternateIDNumber,
      "Product Code": searchCriteria.alternateIDType,
      "View Type": "DirectoryView",
    };
    await commonPublishEvent(
      "Provider Details",
      eventData,
      jwtToken,
      getSessionIdData()
    );
  };

  const [showPopup, setShowPopup] = useState(false);

  const emailResultView = async () => {
    setShowPopup(true);
  };

  useEffect(() => {
    const fetchProviderDetails = async (searchCriteria) => {
      setLoading(true);
      setError(false);
      searchCriteria["language"] = languageData;
      try {
        const data = await fetchData(
          config.NETWORK_DETAIL_URL,
          searchCriteria,
          mycontext
        );
        setMetaData(data.meta);
        if (data.meta && data.meta.statusCode === "A") {
          setJwtTokenData("");
          setRecaptchaTokenData("");
          setSessionIdData(false);
        }
        setDetails(data.details);

        setLoading(false);
      } catch (e) {
        console.error("Error fetching provider details:", e);
        setLoading(false);
        setError(true);
      }
    };

    if (showDetailsResult) {
      fetchProviderDetails(selectedForDetails);
    }
  }, [showDetailsResult, languageData]);

  const handleBackClick = () => {
    setShowDetailResultData(false);
    setSearchPageNumberData(searchPageNumber);
  };

  const renderTable = () => {
    if (metaData?.statusCode === "A") {
      return <ErrorAuthComponent />;
    } else {
      return (
        <ViewProviderDetailsTable
          details={details}
          languageData={languageData}
        />
      );
    }
  };

  const renderContent = () => {
    if (loading) {
      return (
        <Box alignItems="center">
          <CircularProgress data-testid="loading-circle" color="primary" />
        </Box>
      );
    } else {
      return error || metaData?.statusCode == "F" ? (
        <ErrorFallBackComponent />
      ) : (
        renderTable()
      );
    }
  };

  return (
    <Container sx={{ width: "100%", marginY: "2%" }} fixed>
      <Box>
        <div className="box-responsive">
          <div className="dflex-space">
            <div className="linkBoxResp width-50" style={{ textAlign: "left" }}>
              <KeyboardArrowLeftIcon
                style={{ verticalAlign: "middle", color: "green" }}
              />{" "}
              <Link
                href="#"
                style={{ fontWeight: "bold", fontSize: "1.2rem" }}
                onClick={handleBackClick}
              >
                {" "}
                {t(`back`)}
              </Link>
            </div>

            <div className="width-70">
              {(metaData?.statusCode != "F" || metaData?.statusCode != "A") && (
                <div className="dflex">
                  <div className="linkBoxResp width-33" style={{ marginRight: "30px" }}>
                    <CheckIcon
                      style={{ verticalAlign: "middle", color: "#007839" }}
                    />{" "}
                    <a
                      href="#"
                      className="results-link"
                      data-testid="report-link"
                      onClick={handleReportInvalidInformation}
                    >
                      {" "}
                      {t(`reportInvalidInfo`)}
                    </a>{" "}
                  </div>
                  &nbsp;&nbsp;
                  <div  className="width-33" style={{ marginRight: "30px" }}>
                    <ProviderDetailsDownload />{" "}
                  </div>
                  &nbsp;&nbsp;
                  <div className="linkBoxResp width-25">
                    {" "}
                    <EmailIcon
                      style={{ verticalAlign: "middle", color: "#007839" }}
                    />{" "}
                    <a
                      href="#"
                      onClick={emailResultView}
                      className="results-link"
                    >
                      {" "}
                      {t(`emailresults`)}
                    </a>
                  </div>
                  <EmailPopup
                    setShowPopup={setShowPopup}
                    showPopup={showPopup}
                    pageType="detail"
                  />
                </div>
              )}
            </div>
          </div>
          {renderContent()}

          <div className="reportInvalidInformationDiv">
            <Dialog
              className="nationalDialog"
              data-testid="reportInvalidInformationDiv"
              open={showPopupReport}
              onClose={() => setShowPopupReport(false)}
              aria-labelledby="view-national-providers-dialog"
              maxWidth="md"
              fullWidth
              sx={{
                "& .MuiDialog-root": {
                  overflowY: "scroll !important",
                },
                "& .MuiDialog-container": {
                  marginTop: "75rem",
                  marginBottom: "55rem",
                  height: "100vh !important",
                },
                "& .MuiDialog-paper": {
                  maxHeight: "max-content !important",
                  marginTop: "5rem",
                  overflowY: "visible",
                },
              }}
              classes={{
                scrollPaper: classes.topScrollPaper,
                paperScrollBody: classes.topPaperScrollBody,
              }}
            >
              <DialogTitle
                sx={{ fontWeight: "bold", position: "relative" }}
                id="view-national-providers-dialog"
              >
                <h4> {t(`reportInvalidInformation`)} </h4>
                <IconButton
                  edge="end"
                  color="green"
                  onClick={handleCloseReportInvalidInfo}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon sx={{ color: "green" }} />
                </IconButton>
              </DialogTitle>
              <DialogContent
                sx={{
                  paddingLeft: "25px",
                  paddingRight: "25px",
                }}
              >
                <div className="reportInvalidDiv">
                  <p> {t(`pleaseLetUsKnow`)}</p>
                  <p>
                    <span style={{ color: "#007839" }}>
                      <b>
                        {" "}
                        {
                          details?.providerDetails?.practitioner
                            ?.personalDetails?.lastName
                        }
                        ,{" "}
                        {
                          details?.providerDetails?.practitioner
                            ?.personalDetails?.firstName
                        }
                        ,{" "}
                        {
                          details?.providerDetails?.practitioner
                            ?.personalDetails?.middleName
                        }
                        ,{" "}
                        {details?.providerDetails?.practitioner?.educationList
                          ?.education?.length > 0 &&
                          details?.providerDetails?.practitioner?.educationList
                            ?.education[0]?.degree?.degreeCode}
                      </b>
                    </span>{" "}
                    {t(`willBeContacted`)}
                  </p>
                  <p>
                    <span>{t(`areYou`)}</span>{" "}
                    <span>
                      <b>
                        {" "}
                        {
                          details?.providerDetails?.practitioner
                            ?.personalDetails?.lastName
                        }
                        ,{" "}
                        {
                          details?.providerDetails?.practitioner
                            ?.personalDetails?.firstName
                        }
                        ,{" "}
                        {
                          details?.providerDetails?.practitioner
                            ?.personalDetails?.middleName
                        }
                        ,{" "}
                        {details?.providerDetails?.practitioner?.educationList
                          ?.education?.length > 0 &&
                          details?.providerDetails?.practitioner?.educationList
                            ?.education[0]?.degree?.degreeCode}
                        {"?"}
                      </b>
                    </span>
                    <span>
                      {" "}
                      <a
                        href={config.LOGIN_URL}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#007839" }}
                      >
                        <b>{t(`login`)}</b>
                      </a>
                    </span>{" "}
                    <span>{t(`logintext`)}</span>
                  </p>
                  <p>
                    {" "}
                    <b>{t(`whatNeedsToBeCorrected`)}</b>{" "}
                  </p>

                  <div className="checkboxDivProvider">
                    <div className="ml-2p">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={address}
                              onChange={handleChange}
                              name="address"
                              data-testid="dynamic-checkbox-0"
                            />
                          }
                          label={t(`address`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={phone}
                              onChange={handleChange}
                              name="phone"
                              data-testid="dynamic-checkbox-1"
                            />
                          }
                          label={t(`phone`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={gender}
                              onChange={handleChange}
                              name="gender"
                              data-testid="dynamic-checkbox-2"
                            />
                          }
                          label={t(`genderRepo`)}
                        />
                      </FormGroup>
                    </div>

                    <div>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={specialty}
                              onChange={handleChange}
                              name="specialty"
                               data-testid="dynamic-checkbox-3"
                            />
                          }
                          label={t(`specialty`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={deceased}
                              onChange={handleChange}
                              name="deceased"
                               data-testid="dynamic-checkbox-4"
                            />
                          }
                          label={t(`deceased`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={retired}
                              onChange={handleChange}
                              name="retired"
                               data-testid="dynamic-checkbox-5"
                            />
                          }
                          label={t(`retired`)}
                        />
                      </FormGroup>
                    </div>

                    <div>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={noLongerAtThisPracticeAddress}
                              onChange={handleChange}
                              name="noLongerAtThisPracticeAddress"
                               data-testid="dynamic-checkbox-6"
                            />
                          }
                          label={t(`noLonger`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={notAcceptingNewPatients}
                              onChange={handleChange}
                              name="notAcceptingNewPatients"
                               data-testid="dynamic-checkbox-7"
                            />
                          }
                          label={t(`notAccepting`)}
                        />
                      </FormGroup>
                    </div>
                  </div>

                  <div>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      placeholder="Comments"
                      name="comments"
                      value={comments}
                      data-testid="comment-input"
                      onChange={handleCommentChange}
                      multiline
                      rows={4}
                    />
                  </div>
                  <p className="numb">{charLength}/250</p>

                  <p>{t(`youMayAlsoLike`)}</p>
                  <p>
                    <b>
                      <a
                        href="mailto:msaprovidersearchdqrpt@claritev.com"
                        className="mail"
                      >
                        msaprovidersearchdqrpt@claritev.com
                      </a>
                    </b>
                  </p>
                  <p>
                    <b>
                      <a href="tel:866-814-7427" className="mail">
                        866-814-7427
                      </a>
                    </b>
                  </p>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  data-testid="closeBtn"
                  color="primary"
                  sx={{
                    textTransform: "initial",
                    borderRadius: "0px !important",
                  }}
                  onClick={handleCloseReportInvalidInfo}
                  className="font16"
                >
                  {t(`cancelBtn`)}
                </Button>

                <Button
                  variant="contained"
                  data-testid="closeBtn"
                  color="primary"
                  sx={{
                    textTransform: "initial",
                    borderRadius: "0px !important",
                  }}
                  onClick={handleSubmitReport}
                  className="font16"
                  disabled={submitBtn}
                >
                  {t(`submitBtn`)}
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <div className="reportSuccessDiv">
            <Dialog
              className="nationalDialog"
              data-testid="reportSuccessDiv"
              open={showPopupSuccessReport}
              onClose={() => setShowPopupSuccessReport(false)}
              aria-labelledby="view-national-providers-success-dialog"
              maxWidth="md"
              fullWidth
              sx={{
                "& .MuiDialog-root": {
                  overflowY: "scroll !important",
                },
                "& .MuiDialog-container": {
                  marginTop: "75rem",
                  marginBottom: "55rem",
                  height: "100vh !important",
                },
                "& .MuiDialog-paper": {
                  maxHeight: "max-content !important",
                  marginTop: "5rem",
                  overflowY: "visible",
                },
              }}
              classes={{
                scrollPaper: classes.topScrollPaper,
                paperScrollBody: classes.topPaperScrollBody,
              }}
            >
              <DialogTitle
                sx={{ fontWeight: "bold", position: "relative" }}
                id="view-national-providers-dialog"
                data-testid="view-national-providers-dialog"
              >
                <h3> {t(`requestSent`)} </h3>
                <IconButton
                  edge="end"
                  color="green"
                  data-testid="close-Icon"
                  onClick={handleCloseSuccessReportInvalidInfo}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon sx={{ color: "green" }} />
                </IconButton>
              </DialogTitle>
              <DialogContent
                sx={{
                  paddingLeft: "25px",
                  paddingRight: "25px",
                }}
              >
                <div>{t(`reqSuccessMsg`)}</div>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  data-testid="closeBtn"
                  color="primary"
                  sx={{
                    textTransform: "initial",
                    borderRadius: "0px !important",
                  }}
                  onClick={handleCloseSuccessReportInvalidInfo}
                  className="font16"
                >
                  {t(`closeBtn`)}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </Box>
    </Container>
  );
};

export default ViewProviderDetails;
